<template>
  <main>
    <component :is="currentEventComponent" :eventId="id" />
  </main>
</template>
<script>
export default {
  name: 'TermEvent',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      eventComponents: {
        '1': () => import('@/components/event/term/term2025-1-1.vue'),
        '2': () => import('@/components/event/term/term2025-1-2.vue')
        // 필요한 다른 이벤트 컴포넌트들 추가
      }
    }
  },
  computed: {
    currentEventComponent() {
      return this.eventComponents[this.id]
    }
  }
}
</script>
<style lang="scss" scoped>
main {
  width: 100%;
  margin-bottom: 100px;
}
@media (max-width: 480px) {
  main {
    margin-bottom: 0;
  }
}
</style>
